import type { $Enums } from '@prisma/client';
import { getStatusLabel } from '../../../status-labels';
import { definePolicy, type Policy } from '../kernel';
import { deny } from '../types';
import {
  decideHostCharge,
  HOST_CHARGE_FIELDS,
  HOST_CHARGE_OPS,
  type HostChargeFacts,
  type HostChargeField,
  type HostChargeOp,
} from './orderChargeBillLock';

/**
 * The charges window today: every status but COMPLETE, for add and edit alike
 * (`ProductionRunExpensesSection.tsx` `status !== 'COMPLETE'`).
 */
export const PRODUCTION_RUN_CHARGE_EDITABLE_STATUSES: readonly $Enums.ProductionRunStatus[] = ['DRAFT', 'IN_PROGRESS'];

export type ProductionRunExpenseFacts = HostChargeFacts<$Enums.ProductionRunStatus>;

const statusLock = (status: ProductionRunExpenseFacts['hostStatus']) =>
  deny(
    'PRODUCTION_RUN_EXPENSE_CHARGES_LOCKED',
    `Charges are locked once the production run is ${getStatusLabel(status)}.`
  );

/** Production run charges: the shared host charge rule over this host's window (`decideHostCharge`). */
export const productionRunExpensePolicy: Policy<ProductionRunExpenseFacts, HostChargeField, HostChargeOp> =
  definePolicy<ProductionRunExpenseFacts, HostChargeField, HostChargeOp>({
    kind: 'production run charge',
    fields: HOST_CHARGE_FIELDS,
    ops: HOST_CHARGE_OPS,
    requires: {},
    entity: (facts, action) =>
      decideHostCharge(
        { editableStatuses: PRODUCTION_RUN_CHARGE_EDITABLE_STATUSES, statusLock: statusLock(facts.hostStatus) },
        facts,
        action
      ),
  });
